import { useState, useEffect, useRef } from "react";
import { Link as ScrollLink } from "react-scroll";
import { Link as RouterLink, useLocation } from "react-router-dom";
import "../styles/navbar.css";
import logo from "../assets/images/logo.png";
import {
  LuUser,
  LuLayoutList,
  LuSlidersVertical,
  LuAlignRight,
  LuTrophy,
  LuSend,
} from "react-icons/lu";

export default function Navbar() {
  const [initialActive, setInitialActive] = useState(true);
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [isDragging, setIsDragging] = useState(false);
  const location = useLocation();
  const divRef = useRef(null);
  const startY = useRef(0);
  const deltaYRef = useRef(0);
  const isHome = location.pathname === "/";

  const handleTouchStart = (e) => {
    if (window.innerWidth > 767) return;
    startY.current = e.touches[0].clientY;
    setIsDragging(true);
  };

  const handleTouchMove = (e) => {
    if (!isDragging || window.innerWidth > 767) return;

    const currentY = e.touches[0].clientY;
    const deltaY = currentY - startY.current;
    deltaYRef.current = deltaY;

    if (divRef.current && deltaY > 0) {
      divRef.current.style.transform = `translateY(${deltaY}px)`;
    }
  };

  const handleTouchEnd = () => {
    if (window.innerWidth > 767) return;
    if (divRef.current) {
      if (deltaYRef.current > 50) {
        setIsDragging(false);
        setMenuOpen(false);
      } else {
        setIsDragging(true);
        setMenuOpen(true);
      }
    }

    deltaYRef.current = 0;
  };

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 767) {
        setMenuOpen(false);
        if (divRef.current) {
          divRef.current.style.transform = "translateY(0)";
        }
      }
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (divRef.current && !divRef.current.contains(event.target)) {
        setMenuOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    const handleScroll = () => {
      setInitialActive(false);

      window.removeEventListener("scroll", handleScroll);
    };

    if (isHome) {
      window.addEventListener("scroll", handleScroll);
    }
    return () => window.removeEventListener("scroll", handleScroll);
  }, [isHome]);

  useEffect(() => {
    const mainScroll = () => {
      if (window.scrollY >= 5) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };

    mainScroll();

    window.addEventListener("scroll", mainScroll);

    return () => {
      window.removeEventListener("scroll", mainScroll);
    };
  }, []);
  return (
    <>
      <nav
        className={`${scrolled ? "active-scroll" : ""} ${menuOpen ? "active-nav" : ""
          }`}
      >
        <div className="nav-container">
          <div className="nav-container__media">
            <RouterLink to="/">
              <img src={logo} alt="Logo" loading="lazy" />
            </RouterLink>
          </div>
          <button
            className="nav-menu"
            onClick={() => {
              setMenuOpen(true);
            }}
          >
            <LuAlignRight />
          </button>
          <div
            className={`nav-container__links ${menuOpen ? "menu-open" : "menu-closed"
              }`}
            ref={divRef}
            onTouchStart={handleTouchStart}
            onTouchMove={handleTouchMove}
            onTouchEnd={handleTouchEnd}
            style={{
              touchAction: "none",
            }}
          >
            <div className="nav-container__links-wrapper">
              <RouterLink to="/" className={location.pathname === "/" ? "active-route" : ""}>Home</RouterLink>
              <RouterLink to="/about" className={location.pathname === "/about" ? "active-route" : ""}>About</RouterLink>
              <RouterLink to="/contact" className={location.pathname === "/contact" ? "active-route" : ""}>Contact</RouterLink>
            </div>
          </div>
        </div>
      </nav>
      {isHome && (
        <div className="scroll-links">
          <ScrollLink
            to="hero"
            smooth={true}
            duration={500}
            spy={true}
            activeClass="active"
            className={`scroll-link ${initialActive ? "active" : ""}`}
          >
            <LuUser />
          </ScrollLink>

          <ScrollLink
            to="skills"
            smooth={true}
            duration={500}
            spy={true}
            activeClass="active"
            className="scroll-link"
          >
            <LuSlidersVertical />
          </ScrollLink>

          <ScrollLink
            to="success"
            smooth={true}
            duration={500}
            spy={true}
            activeClass="active"
            className="scroll-link"
          >
            <LuTrophy />
          </ScrollLink>

          <ScrollLink
            to="projects"
            smooth={true}
            duration={500}
            spy={true}
            activeClass="active"
            className="scroll-link"
          >
            <LuLayoutList />
          </ScrollLink>
          <ScrollLink
            to="mail"
            smooth={true}
            duration={500}
            spy={true}
            activeClass="active"
            className="scroll-link"
          >
            <LuSend />
          </ScrollLink>
        </div>
      )}
    </>
  );
}
